import styled from 'styled-components';

export const AvatarWrapper = styled.div`
    position: static;
    display: inline-block;
    right: auto;
`;
